// // 認証エラー
// export class AuthFailError extends Error {
//   static {
//     this.prototype.name = "AuthFailError";
//   }
// }
// export class UnauthorizedError extends Error {
//   static {
//     this.prototype.name = "UnauthorizedError";
//   }
// }

// /**
//  * 入力チェックエラー
//  */
// export class InputError extends Error {
//   static {
//     this.prototype.name = "InputError";
//   }
// }

// //   https://www.wantedly.com/companies/wantedly/post_articles/492456

export class APIError extends Error {
  // static {
  //   this.prototype.name = "APIError";
  // }
  constructor(message = "", options = {}) {
    const { status, ...rest } = options;
    // causeがあるときはErrorに渡される
    super(message, rest);
    this.name = "APIError";
    this.status = status;
  }
}
